import { Layers, RectangleHorizontal, ScanLine } from "@/components/icons";

export const PHOTO_ANGLES = [
  {
    icon: ScanLine,
    title: "Top view",
    description: "Straight down on the top face",
  },
  {
    icon: RectangleHorizontal,
    title: "Side view",
    description: "Eye-level profile shot showing depth",
  },
  {
    icon: Layers,
    title: "Stack view",
    description: "The whole stack, to judge quantity",
  },
] as const;

export function PhotoAngleGuide() {
  return (
    <div className="rounded-lg border bg-muted/30 p-4">
      <p className="mb-3 text-center text-sm font-medium text-muted-foreground">
        Take these three angles:
      </p>
      <div className="grid grid-cols-1 gap-3 md:grid-cols-3">
        {PHOTO_ANGLES.map(({ icon: Icon, title, description }) => (
          <div
            key={title}
            className="flex items-center gap-3 rounded-md bg-background/60 p-3"
          >
            <div className="shrink-0 rounded-full bg-muted p-2">
              <Icon className="h-4 w-4 text-muted-foreground" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-medium leading-none">{title}</p>
              <p className="mt-1 line-clamp-2 text-xs text-muted-foreground">
                {description}
              </p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export function PhotoAngleList() {
  return (
    <ol className="space-y-4">
      {PHOTO_ANGLES.map(({ icon: Icon, title, description }) => (
        <li key={title} className="flex items-start gap-3">
          <Icon className="mt-0.5 size-4 shrink-0 text-muted-foreground" aria-hidden />
          <div className="min-w-0">
            <p className="text-sm font-medium text-foreground">{title}</p>
            <p className="text-xs text-muted-foreground">{description}</p>
          </div>
        </li>
      ))}
    </ol>
  );
}
